<template>
    <p class="leading-tighter">
        <span class="heading-font text-sm uppercase font-normal mg-color-secondary-lighter">{{ display_date }}</span>
        <br />
        <a :href="post.link">
            <span class="text-lg leading-tight">{{ title }}</span>
        </a>
    </p>    
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'ml-news-item',
  props: ['post'],
  data() {
    return {
      summary: '',      
      display_date: ''
    }
  },
  computed: {
    title() {
      return this.post.post_title || this.post.title.rendered
    }
  },
  methods: {
    makeSummary() {
        let excerptSource = this.post.excerpt && this.post.excerpt.rendered ? this.post.excerpt.rendered : this.post.content.rendered;

        const $htmlHolder = $('<div />')

        const contentPreview =
            excerptSource
            .split(' ')
            .splice(0, 15)
            .join(' ') + '...'

        $htmlHolder.html(contentPreview)

        this.summary = $htmlHolder.text()      
    },
    addDisplayDate() {
      this.display_date = format(this.post.date, 'MMM D, YYYY')
    },
    updateMeta() {      
      this.addDisplayDate()
      this.makeSummary()
    }
  },
  updated() {
    this.updateMeta()
  },
  created() {
    this.updateMeta()
  }
}
</script>



// WEBPACK FOOTER //
// src/js/vue-components/ml-news-item.vue